__turbopack_context__.v({
  "container": "transactional-sticky-footer-content-module-scss-module__pZu0Ca__container",
  "transactional-cta-button": "transactional-sticky-footer-content-module-scss-module__pZu0Ca__transactional-cta-button",
});
